module.exports = __webpack_public_path__ + "img/victor-mono-dark.32c2b8aa.png";